<template>
  <div class="qir-clients__wrapper full-width-section">
    <div class="qir-clients__container">
      <h2 class="qir-clients__title title">
        Trusted by Leading Industry Players
      </h2>

      <qir-clients-slider :clients="$options.consts.CLIENTS" />
    </div>
  </div>
</template>

<script>
import QirClientsSlider from 'sections/_qir/QirClients/QirClientsSlider/index.vue'

export default {
  name: 'QirClients',
  components: { QirClientsSlider },
  consts: {
    CLIENTS: [
      {
        imageUrl: '/images/clients/meta-quotes.png',
        altText: 'Meta quotes company logo',
        link: 'https://www.metaquotes.net/en'
      },
      {
        imageUrl: '/images/clients/equity-capital.png',
        altText: 'Equity Capital company logo',
        link: 'https://www.equiti.com/sc-en/'
      },
      {
        imageUrl: '/images/clients/jane-street.png',
        altText: 'Jane Street company logo',
        link: 'https://www.janestreet.com/'
      },
      {
        imageUrl: '/images/clients/xm.png',
        altText: 'XM company logo',
        link: 'https://www.xm.com/'
      },
      {
        imageUrl: '/images/clients/iron-fx.png',
        altText: 'Iron FX company logo',
        link: 'https://www.iforex.com/'
      },
      {
        imageUrl: '/images/clients/deriv.png',
        altText: 'Deriv company logo',
        link: 'https://deriv.com/eu'
      },
      {
        imageUrl: '/images/clients/capital-com.png',
        altText: 'Capital com company logo',
        link: 'https://capital.com/'
      },
      {
        imageUrl: '/images/clients/axi.png',
        altText: 'Axi company logo',
        link: 'https://www.axi.com'
      },
      {
        imageUrl: '/images/clients/fbs.png',
        altText: 'FBS company logo',
        link: 'https://fbs.com/'
      },
      {
        imageUrl: '/images/clients/epam.png',
        altText: 'epam company logo',
        link: 'https://www.epam.com/'
      },
      {
        imageUrl: '/images/clients/cmc-markets.png',
        altText: 'cmc markets company logo',
        link: 'https://www.cmcmarkets.com/en/'
      },
      {
        imageUrl: '/images/clients/fxcm-pro.png',
        altText: 'FXCM company logo',
        link: 'https://www.fxcm.com/eu/'
      },
      {
        imageUrl: '/images/clients/avatrade.png',
        altText: 'Avatrade company logo',
        link: 'https://www.avatrade.com/'
      },
      {
        imageUrl: '/images/clients/purprime.png',
        altText: 'Purprime company logo',
        link: 'https://www.puprime.com/'
      },
      {
        imageUrl: '/images/clients/iforex.png',
        altText: 'iforex company logo',
        link: 'https://www.iforex.com/'
      },
      {
        imageUrl: '/images/clients/ic-markets.png',
        altText: 'IC Markets company logo',
        link: 'https://www.icmarkets.eu'
      }
    ]
  }
}
</script>

<style lang="scss" scoped>
.qir-clients__wrapper {
  background-color: $c--gray-dark;

  .qir-clients__container {
    max-width: $desktop-container;

    $padding: (
      $above-desktop-xl: 96px $padding-x-desktop-full-hd,
      $desktop-md: 64px $padding-x-desktop-md,
      $mobile: 32px $padding-x-mobile
    );

    @include setStyleByBreakpoint('padding', $padding);
  }

  .qir-clients__title {
    $margin-bottom: (
      $above-desktop-xl: 64px,
      $mobile: 32px
    );

    @include setStyleByBreakpoint('margin-bottom', $margin-bottom);
  }
}
</style>
